angular.module('qkr').service('corsService', (messageService, $q, gettextCatalog) => {
    // Create the XHR object.
    function createCORSRequest(method, url) {
        let xhr = new XMLHttpRequest();
        if ('withCredentials' in xhr) {
            // XHR for Chrome/Firefox/Opera/Safari.
            xhr.open(method, url, true);
        } else if (typeof XDomainRequest !== 'undefined') {
            // XDomainRequest for IE.
            xhr = new XDomainRequest();
            xhr.open(method, url);
        } else {
            // CORS not supported.
            xhr = null;
        }
        return xhr;
    }

    const root = {};

    // Make the actual CORS request.
    root.makeCorsRequest = function(url) {
        const deferred = $q.defer();

        // All HTML5 Rocks properties support CORS.
        // Var url ='https://maps.googleapis.com/maps/api/timezone/json?location=39.6034810,-119.6822510&timestamp=1331161200';

        const xhr = createCORSRequest('GET', url);

        if (!xhr) {
            messageService.error('CORS not supported');

            return;
        }

        // Response handlers.
        xhr.onload = function() {
            const text = xhr.responseText;

            const jsonResponse = angular.fromJson(text);

            if (jsonResponse.status && (jsonResponse.status !== 200 && jsonResponse.status !== 'OK')) {
                deferred.reject(gettextCatalog.getString('Problem to get the latitude/longitude,') + ' ' + jsonResponse.errorMessage);
            } else {
                deferred.resolve(jsonResponse);
            }
        };

        xhr.onerror = function() {
            messageService.error('Woops, there was an error making the request.');

            deferred.reject(gettextCatalog.getString('Woops, there was an error making the request.'));
        };

        xhr.send();

        return deferred.promise;
    };

    return root;
});



// WEBPACK FOOTER //
// ./src/services/cors.service.js